import React from "react";
import { MultiSelect } from "react-multi-select-component";
import * as styles from "./filter-select.module.scss";

const FilterSelect = ({
  options,
  value,
  labelledBy,
  onChange,
  allItemsAreSelected,
  selectAll,
  selectSomeItems,
}) => {
  return (
    <MultiSelect
      disableSearch
      options={options}
      value={value}
      labelledBy={labelledBy}
      onChange={onChange}
      overrideStrings={{
        allItemsAreSelected,
        selectAll,
        selectSomeItems,
      }}
      className={styles?.filter}
    />
  );
};

export default FilterSelect;
